export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M3.553 9.894A1 1 0 004.8 8.4a4 4 0 117.12-1.6 1 1 0 001.96.4A6 6 0 102 6a5.94 5.94 0 001.2 3.6 1 1 0 00.353.294zm15.86 1.666c.367.36.578.85.587 1.364V16.076A8 8 0 0112 24a7.243 7.243 0 01-5.121-2.12l-.81-.81L3.999 19l-2.5-2.5a2.023 2.023 0 112.857-2.867L6 15.277V6a1.962 1.962 0 011.962-1.962h.076A1.962 1.962 0 0110 6v4.838h.013A1.956 1.956 0 0111.962 9h.076a1.957 1.957 0 011.847 1.324c.32-.211.694-.324 1.077-.324h.076a1.957 1.957 0 011.847 1.324c.32-.211.694-.324 1.077-.324h.076c.514 0 1.008.2 1.375.56z\" fill=\"#3F4450\"/>",
  "attrs": {
    "width": "20",
    "height": "24",
    "viewBox": "0 0 20 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};